module.exports = {
	"apertureWidth": "Diyafram Genişliği",
	"apertureLength": "Diyafram Uzunluğu",
	"apertureGap1": "Diyafram Boşluğu 1",
	"apertureGap2": "Diyafram Boşluğu 2",
	"ballDiameter": "Bilye Çapı",
	"bodyOffset": "Gövde Ofseti",
	"bodyLength": "Gövde Uzunluğu",
	"bodyDiameter": "Gövde Çapı",
	"bodyHeight": "Gövde Yüksekliği",
	"bodyColor": "Gövde Rengi",
	"componentFamily": "Bileşen Ailesi",
	"colPitch": "Sütun Aralığı",
	"chipArrayNote": "* L1 ve b1 isteğe bağlıdır.",
	"crystalNote": "* (D, D2, L) arasından isteğe bağlı boyutu seçin. Farklı kombinasyonlarla farklı ayak izi ped ölçüleri üretilebilir.",	
	"densityLevel": "Yoğunluk Seviyesi",	
	"femaleStandoffNote": "* Montaj deliği pedi isteğe bağlıdır ve soldaki resimde gösterilen boyutlar için değerler girilerek oluşturulabilir. Delik çapı (b), montaj deliği oluşturma ve iç diş açma olmayan ara parça mekanik modeli için kullanılır.",
	"footprintOrigin": "Ayak İzi Orijini",
	"hPinPitch": "Yatay Bacak Aralığı",
	"hTerminalGap": "Yatay Terminal Boşluğu",
	"hTerminalTailLength": "Yatay Terminal Kuyruk Uzunluğu",
	"innerThreadDepth": "İç Diş Derinliği",
	"innerThreadSize": "İç Diş Ölçüsü",
	"innerThreadDesignation": "İç Diş Tanımı",
	"leadDiameter": "Uç Çapı",
	"leadSpan": "Uç Açıklığı",
	"leadSpan1": "Uç Açıklığı 1",
	"leadSpan2": "Uç Açıklığı 2",
	"leadShape": "Uç Şekli",
	"largerTerminalLength": "Daha Büyük Terminal Uzunluğu",
	"largerTerminalWidth": "Daha Büyük Terminal Genişliği",
	"maleFemaleStandoffNote": "* Montaj deliği pedi isteğe bağlıdır ve soldaki resimde gösterilen boyutlar için değerler girilerek oluşturulabilir. Delik çapı (b) montaj deliği oluşturmak için kullanılır.",
	"mapSilkscreen": "Serigrafiyi Gövdeye Eşle",
	"optionalDimensionNote": "* (D, D2, L) arasından isteğe bağlı boyutu seçin. Farklı kombinasyonlarla farklı ayak izi ped ölçüleri üretilebilir.",
	"oddTerminalLength": "Tek Terminal Uzunluğu",
	"oddTerminalWidth": "Tek Terminal Genişliği",
	"optionalDimension": "İsteğe Bağlı Boyut",	
	"partialThread": "Kısmi Diş",	
	"pasteCoverage": "Pasta Kapsamı",
	"producibilityLevel": "Üretilebilirlik Seviyesi",
	"pinPitch": "Bacak Aralığı",
	"padToHoleRatio": "Ped - Delik Oranı",
	"padRoundness": "Ped Yuvarlaklığı",
	"pinNumbering": "Bacak Numaralandırma",
	"postLength": "Direk Uzunluğu",
	"postThreadSize": "Direk Dişi Ölçüsü",
	"postThreadDesignation": "Direk Dişi Tanımı",
	"rowPitch": "Satır Aralığı",
	"tabWidth": "Sekme Genişliği",
	"tabLength": "Sekme Uzunluğu",
	"terminalThickness": "Terminal Kalınlığı",
	"terminalWidth": "Terminal Genişliği",
	"terminalLength": "Terminal Uzunluğu",
	"terminalGap": "Terminal Boşluğu",
	"terminalCCGap": "Terminal Merkezi-Merkez Boşluğu",
	"terminalCCGap1": "Terminal Merkezi-Merkez Boşluğu 1",
	"terminalCCGap2": "Terminal Merkezi-Merkez Boşluğu 2",
	"terminalTailLength": "Terminal Kuyruk Uzunluğu",
	"terminalPostLength": "Terminal Direk Uzunluğu",
	"terminalType": "Terminal Tipi",	
	"threadDepth": "Diş Derinliği",
	"threadSize": "Diş Ölçüsü",
	"threadDesignation": "Diş Tanımı",	
	"threaded": "Vida",
	"truncateMiddlePin": "Orta Bacağı Kısalt",		
	"vPinPitch": "Dikey Bacak Aralığı",
	"vTerminalGap": "Dikey Terminal Boşluğu",
	"vTerminalTailLength": "Dikey Terminal Kuyruk Uzunluğu",
	"#Rows": "# Satırlar",
	"#Cols": "# Sütunlar",
	"#Pins": "# Bacaklar",
	"#DPins": "# Bacaklar (D Yanı)",
	"#EPins": "# Bacaklar (E yanı)",
	"padShape": "Ped Şekli",
	"RESISTOR": "Direnç",
	"NONPOLARIZED_CAPACITOR": "Kondansatör - Polarize edilmemiş",
	"POLARIZED_CAPACITOR": "Polarize Edilmiş Kondansatör",
	"DIODE": "Diyot",
	"FUSE": "Sigorta",
	"INDUCTOR": "İndüktör (Bobin)",
	"POLARIZED_INDUCTOR": "Polarize Edilmiş İndüktör",
	"NONPOLARIZED_INDUCTOR": "İndüktör - Polarize edilmemiş",
	"LRCCW": "Sol alttan saat yönünün tersine",
	"LRCW": "Sol üstten saat yönünde",
	"ZZBT": "Sol alttan ZigZag",
	"PIN_ONE": "Bacak 1",
	"CENTER_PADS": "Pedlerin merkezi",
	"female": "Dişi",
	"male": "Erkek",
	"maleFemale": "Erkek-Dişi",
	"ROUND": "Yuvarlak",
	"HEX": "Altıgen",
	"SQUARE": "Kare",
	"Round": "Yuvarlak",
	"Square": "Kare",
	"RoundedSquare": "Yuvarlatılmış Kare",
	"Rectangle": "Dikdörtgen",
	"Black": "Siyah",
	"Green": "Yeşil",
	"Blue": "Mavi",
	"Yellow": "Sarı",
	"Amber": "Kehribar",
	"Brown": "Kahverengi",
	"Cyan": "Camgöbeği",
	"Maroon": "Bordo",
	"Grey": "Gri",
	"Silver": "Gümüş",
	"Purple": "Mor",
	"Red": "Kırmızı",
	"White": "Beyaz",
	"Most (A)": "En Fazla (A)",
	"Nominal (B)": "Nominal (B)",
	"Least (C)": "En Az (C)",
	"Most (M)": "En Fazla (M)",
	"Nominal (N)": "Nominal (N)",
	"Least (L)": "En Az (L)",
	"IC": "Entegre Devre (IC)",
	"PRECISION_INDUCTOR": "Hassas İndüktör",
	"LED": "LED",
	"THERMISTOR": "Termistör",
	"POLARIZED_DIODE": "Diyot",
	"VARISTOR": "Varistör",
	"FERRITE_BEAD": "Ferrit Boncuk",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "Çip",
	"SOD": "SOD",
	"MOLDED_BODY": "Kalıplanmış Gövde",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "Kristal",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "Çip Dizisi, 2 Taraflı Düz/İçbükey",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "Çip Dizisi, 4 Taraflı Düz/İçbükey",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "Çip Dizisi, 2 Taraflı Dışbükey",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "Osilatör Köşe İçbükey",
	"OSCILLATOR_J_LEAD": "Osilatör J Uç",
	"OSCILLATOR_L_BEND": "Osilatör L Büküm",
	"SOJ": "SOJ",
	"AXIAL": "Eksenel",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "Bacak Başlığı (Erkek) Düz",
	"PIN_HEADER_RA": "Bacak Başlığı (Erkek) Sağ Açı",
	"RECEPTACLE_HEADER_STRAIGHT": "Soket Başlığı (Dişi) Düz",
	"RECEPTACLE_HEADER_RA": "Soket Başlığı (Dişi) Sağ Açı",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "Radyal Genel (Yuvarlak)",
	"RADIAL_LED": "Radyal LED (Yuvarlak)",
	"CRYSTAL_HC49": "Kristal (HC49)",
	"FEMALE_STANDOFF": "Dişi Distans/Ara Parçası",
	"MALE_FEMALE_STANDOFF": "Erkek-Dişi Distans",
	"SNAP_LOCK": "Tırnaklı Distans",
	"Optional_D": "D (Uç Açıklığı)",
	"Optional_D2": "D2 (Terminal Boşluğu)",
	"Optional_L": "L (Terminal Uzunluğu)",
	"CONCAVE": "İçbükey",
	"FLAT": "Düz",
	"Oblong": "Dikdörtgen",
	"Collapsing_Ball": "Küçülen Bilye",
	"Non_Collapsing_Ball": "Küçülmeyen Bilye",
	"mountingHolePad": "Montaj Deliği Pedi",
	"withVias": "Yollar ile",
	"viasCount": "Yol Sayısı",
	"viaDiameter": "Yol Çapı",
	"viaOffset": "Delik Merkezinden Yol Ofseti",
	"viaThermalRelief": "Termal Rölyef yoluyla",
	"radialLedNote": "* c yuvarlatılmış uç şekli için geçerli değildir.",
	"lockHeight": "Kilit Yüksekliği",
	"overrideLockDiameter": "Kilit Çapını Geçersiz Kıl",
	"lockDiameter": "Kilit Çapı",
	"overridePitch": "Bacak Aralığını Geçersiz Kıl",
	"bodyWidth": "Gövde Genişliği",
	"padWidth": "Ped Genişliği",
	"plated": "Kaplamalı",
	"ViaOffset": "Delik Merkezinden Yol Ofseti",
	"holeDiameter": "Delik Çapı",
	"snapLockNote1": "* Kilit çapı (E1) gövde çapına (E) ve delik çapına (b) göre otomatik olarak hesaplanır. Ancak kilit çapını geçersiz kılarak özel bir değer girebilirsiniz.",
	"snapLockNote2": "* Delik çapı (b), gövde çapına (E) ve kilit çapına (E1) eşit olmamalıdır.",
	"leadWidth": "Uç Genişliği",
	"leadThickness": "Uç Kalınlığı",
	"boardThickness": "Kart Kalınlığı",
	"error1": "Uygulanmadı.",
	"fabricationTolerance": "İmalat Toleransı", 
	"placementTolerance": "Yerleştirme Toleransı",
	"CAPACITOR": "Kondansatör - Polarize edilmemiş",
	"CAPACITOR_NONPOLARIZED": "Kondansatör - Polarize edilmemiş",
	"CAPACITOR_NON_POLARIZED": "Kondansatör - Polarize edilmemiş",
	"FILTER": "Filtre", 
	"TRANSISTOR": "Transistör",
	"ecapNote": "* (D, D2, L) arasından isteğe bağlı boyutu seçin. Farklı kombinasyonlarla farklı ayak izi ped ölçüleri üretilebilir.",
	"maximum": "Maksimum", 
	"nominal": "Nominal", 
	"minimum": "Minimum",
	"bodyShape": "Gövde Şekli",
	"customSolderPaste": "Özel Lehim Pastası",
	"thermalPad": "Termal Ped",
	"thermalPadLength": "Termal Ped Uzunluğu",
	"thermalPadWidth": "Termal Ped Genişliği",
	"RoundedRectangle": "Yuvarlatılmış Dikdörtgen",
	"extendedEdgeLength": "Uzatılmış Kenar Uzunluğu",
	"Generator": " Oluşturucu",
	"axialNote": "* Bacak aralığı, ayak izini IPC uyumlu hale getirmek için gövde boyutuna, terminale ve üretilebilirlik seviyesine göre otomatik olarak hesaplanır.  Ancak, IPC uyumlu olmayan ayak izi oluşturmak için bacak aralığını geçersiz kılarak özel değer sağlayabilirsiniz.",
	"baseHeight": "Taban Yüksekliği",
	"CHIP_LED": "Çip LED",
	"updatePreview": "Güncelleme Ön İzlemesi",
	"Custom": "Özel",
	"ledColorNote": "* Özel gövde rengi için değeri Onaltılı biçimde girin.",
	"customBodyColor": "Özel Gövde Rengi",							
	"lensShape": "Lens Şekli",
	"domeDiameter": "Kubbe Çapı",
	"RECT_FLAT_TOP": "Düz Üstlü Dikdörtgen",
	"RECT_DOMED_TOP": "Kubbe Üstlü Dikdörtgen",
	'customFootprint': 'Özel Ayak İzi',
	'customPadLength': 'Özel Ped Uzunluğu',
	'customPadWidth': 'Özel Ped Genişliği',
	'customPadGap': 'Özel Pedden Pede Boşluk',
	'customOddPadWidth': 'Özel Tek Ped Genişliği',
	'customOddPadLength': 'Özel Tek Ped Uzunluğu',
	'customPadDiameter': 'Özel Ped Çapı',
	'customPadSpan1': 'Özel Ped Aralığı 1',
	'customPadSpan2' : 'Özel Ped Açıklığı 2',
	'customPadPitch' : 'Özel Ped Aralığı',
	'pinPitch1' : 'Bacak Aralığı 1',
	'customPadGap1': 'Özel Pedden Pede Boşluk 1',
	'Optional_g': 'g (Özel Ped Boşluğu)',
	'Optional_p': 'p (Özel Ped Aralığı)',

	// JS Widgets
	"New_Library": "Yeni Kütüphane",
	"Components": "Bileşenler",
	"Component": "Bileşen",
	"Symbols": "Semboller",
	"Symbol": "Sembol",
	"Footprints": "Ayak izleri",
	"Footprint": "Ayak izi",
	"Packages": "Paketler",
	"Package": "Paket",
	"No": "Hayır",
	"Name": "Ad",
	"Pins": "Bacaklar",
	"Pads": "Pedler",
	"Description": "Açıklama",
	"Variants": "Varyantlar",
	"Type": "Tip",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io URN",
	"Library_io_Version": "Library.io Sürümü",
	"Link": "Bağlantı",
	"Rename": 'Yeniden Adlandır',
	"Edit_Description": 'Açıklamayı Düzenle',
	"Duplicate": 'Çoğalt', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": 'Yeni 3B Model Oluştur',
	"Attach_Copy_Existing_3D_Model": 'Mevcut 3B Modelin Kopyasını Ekle',
	"Edit": 'Düzenle',
	"Delete": 'Sil',
	"Remove_From": 'Şuradan Kaldır:',
	"Update_To_Latest": 'En Son Sürüme Güncelle',
	"Create_New_Symbol": 'Yeni Sembol Oluştur',
	"Create_New_Footprint": 'Yeni Ayak İzi Oluştur',
	"Create_New_Component": 'Yeni Bileşen Oluştur',
	"Create_New_Package": 'Yeni Paket Oluştur',
	"Delete_Package_Children_Warning": "Ayrıca bu, bu ayak izi tarafından kullanılan paketleri de siler.",
	"No_Search_Results": "Arama Sonucu yok",
	"No_Library_Loaded": "Kütüphane Yüklenmedi",
	"Library_Stored_Fusion_Hub": "Bu kütüphane your Fusion Hub'de saklanır.",
	"Library_Linked_Managed_Library": "Bu kütüphane, bir Library.io Yönetilen Kütüphanesi ile bağlıdır.",
	"Library_Local_Changes": "Bu kütüphanede Library.io'ya gönderilmemiş değişiklikler var.  Bunu yapmak için 'Yönet' araç çubuğuna gidin.",
	"Library_Remote_Changes": "Bu kütüphane, Library.io'dan alınabilecek yeni güncellemelere sahiptir.  Bunu yapmak için 'Yönet' araç çubuğuna gidin.",
	"View_on_Library_io": "Library.io'da görüntüleyin",
	"Used_In": "Şurada Kullanılan",
	"No_Selection": "Seçim yok",

	"No_Footprints": "Ayak İzi yok",
	"No_Symbols": "Sembol yok",
	"No_Components": "Bileşen yok",
	"No_Packages": "Paket yok",

	"Package_Loading_Message": "Paket kaydedilip yüklenirken lütfen bekleyin.",
	"Attributes": "Öz Nitelikler",
	"View_Attributes": "Öz Nitelikleri Görüntüle",
	"Edit_Attributes": "Öz Nitelikleri Görüntüle",
	"Edit_Description": "Açıklamayı Düzenle",
	
	"Use_Placeholder": "Yer Tutucuyu Kullan",
	"Placeholder_Message": "Ayak iziyle ilişkilendirilmiş bir 3B model olmadığında yer tutucu şekli kullanın.",

	"Hub": "Hub",
	"New_Symbol": 'Yeni Sembol',
	"New_Footprint": 'Yeni Ayak İzi',
	"New_Component": 'Yeni Bileşen',
	"New_Package": 'Yeni Paket',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Library.io paketi güncellemesi mevcut.  Sağ tıklayın ve Güncelle'yi seçin.",
	"Package_Behind_Fusion": "Fusion paketi güncellemesi mevcut.  Sağ tıklayın ve Güncelle'yi seçin.",
	"Package_Behind_Both": "Bir paket güncellemesi mevcut.  Sağ tıklayın ve Güncelle'yi seçin.",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "Varlık değişikliklerinin alınabilmesi için kütüphanenin güncellenmesi gerekir.  Kütüphaneyi güncellemek için 'Yönet' araç çubuğunu kullanın.",
}